import React from "react";
import styles from "../../styles/pages/user/user-copywriter-video-titling.module.scss";
import { Box } from "@mui/system";
import { Link, List, ListItem } from "@mui/material";

const UserCopywriterVideoTitling = (videoTitlingSummary) => {
  return (
    <Box className={styles.videoTitling}>
      <h4>Video Titling Summary</h4>
      <List>
        <ListItem>
          <Link href="">
            Titled videos
            <span>{videoTitlingSummary?.videoTitlingSummary?.titled}</span>
          </Link>
        </ListItem>
        <ListItem>
          <Link href="">
              Revision requests
            <span>
              {videoTitlingSummary?.videoTitlingSummary?.revision_requests}
            </span>
          </Link>
        </ListItem>
        <ListItem>
          <Link href="">
            Revised titles
            <span>
              {videoTitlingSummary?.videoTitlingSummary?.revisted_titles}
            </span>
          </Link>
        </ListItem>
        <ListItem>
          <Link href="">
            Pending revision
            <span>
              {videoTitlingSummary?.videoTitlingSummary?.pendingRevision}
            </span>
          </Link>
        </ListItem>
      </List>
    </Box>
  );
};

export default UserCopywriterVideoTitling;
